/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../helper/URLHelper';
import KanbanView from '../conversation/KanbanView.vue';
import ManageFunnels from '../conversation/ManageFunnels.vue';
import FunnelSettings from '../conversation/FunnelSettings.vue';
import ContactImport from '../conversation/ContactImport.vue';

const CONVERSATION_PERMISSIONS = [
  'administrator',
  'agent',
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export default {
  routes: [
    // Rotas do Kanban/Funil - completamente separadas
    {
      path: frontendURL('accounts/:accountId/kanban'),
      name: 'kanban_view',
      meta: {
        permissions: CONVERSATION_PERMISSIONS,
      },
      component: KanbanView,
      props: () => ({ viewType: 'kanban' }),
    },
    {
      path: frontendURL('accounts/:accountId/kanban/funnel/:funnelId'),
      name: 'kanban_funnel_view',
      meta: {
        permissions: CONVERSATION_PERMISSIONS,
      },
      component: KanbanView,
      props: route => ({
        viewType: 'kanban',
        funnelId: route.params.funnelId,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/funnels/manage'),
      name: 'manage_funnels',
      meta: {
        permissions: ['administrator'],
      },
      component: ManageFunnels,
    },
    {
      path: frontendURL('accounts/:accountId/funnels/:funnelId/settings'),
      name: 'funnel_settings',
      meta: {
        permissions: ['administrator'],
      },
      component: FunnelSettings,
      props: route => ({ funnelId: route.params.funnelId }),
    },
    {
      path: frontendURL('accounts/:accountId/contacts/import'),
      name: 'contact_import',
      meta: {
        permissions: ['administrator'],
      },
      component: ContactImport,
    },
  ],
};
